"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _models = require("@seedlang/models");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _utils = require("@seedlang/utils");
var _class, _descriptor, _descriptor2, _descriptor3;
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var UserInputStore = (_class = /*#__PURE__*/function (_RootModel) {
  function UserInputStore(mediaStore) {
    var _this;
    (0, _classCallCheck2["default"])(this, UserInputStore);
    _this = _callSuper(this, UserInputStore);
    (0, _initializerDefineProperty2["default"])(_this, "inputType", _descriptor, _this);
    (0, _initializerDefineProperty2["default"])(_this, "messageInput", _descriptor2, _this);
    (0, _initializerDefineProperty2["default"])(_this, "caretPosition", _descriptor3, _this);
    _this.mediaStore = mediaStore;
    return _this;
  }
  (0, _inherits2["default"])(UserInputStore, _RootModel);
  return (0, _createClass2["default"])(UserInputStore, [{
    key: "unselectedInputType",
    get: function get() {
      return (0, _utils.isBlank)(this.inputType);
    }
  }, {
    key: "hasMessageInput",
    get: function get() {
      return (0, _utils.isPresent)(this.messageInput);
    }
  }, {
    key: "videoActiveInput",
    get: function get() {
      return this.inputType === 'video';
    }
  }, {
    key: "audioActiveInput",
    get: function get() {
      return this.inputType === 'audio';
    }
  }, {
    key: "textActiveInput",
    get: function get() {
      return this.inputType === 'text';
    }
  }, {
    key: "recordingActiveInput",
    get: function get() {
      return this.audioActiveInput || this.videoActiveInput;
    }
  }, {
    key: "setInputType",
    value: function setInputType(inputType) {
      this.inputType = inputType;
    }
  }, {
    key: "insertText",
    value: function insertText(text) {
      if (typeof document !== 'undefined') {
        var el = document.getElementById('user-input');
        if (el) {
          var caretPosition = el.selectionStart;
          var newValue = [this.messageInput.slice(0, caretPosition), text, this.messageInput.slice(caretPosition)].join('');
          this.caretPosition = caretPosition + 1;
          this.messageInput = newValue;
        }
      }
    }
  }, {
    key: "onUpdateMessageInput",
    value: function onUpdateMessageInput(value) {
      this.messageInput = value;
      if (typeof document !== 'undefined') {
        var el = document.getElementById('user-input');
        if (el) {
          this.caretPosition = el.selectionStart;
        }
      }
    }
  }, {
    key: "onMediaReset",
    value: function onMediaReset() {
      if (this.mediaStore.isRecording) {
        this.mediaStore.stopRecording({
          skipCallback: true,
          skipCreateObjectURL: true
        });
      }
      this.mediaStore.onSoftReset();
    }
  }, {
    key: "onRecordAudio",
    value: function onRecordAudio() {
      if (!this.mediaStore.isRecording) {
        this.setInputType('audio');
        this.mediaStore.onReset();
        this.mediaStore.recordAudio();
      }
    }
  }, {
    key: "onStopRecordingAudio",
    value: function onStopRecordingAudio() {
      this.mediaStore.stopRecording();
      this.mediaStore.setUrl(this.mediaStore.objectUrl);
    }
  }, {
    key: "onToggleRecordAudio",
    value: function onToggleRecordAudio() {
      if (this.mediaStore.isRecording) {
        this.onStopRecordingAudio();
      } else {
        this.onRecordAudio();
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.inputType = '';
      this.messageInput = '';
    }
  }]);
}(_models.RootModel), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "inputType", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "messageInput", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "caretPosition", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "unselectedInputType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "unselectedInputType"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "hasMessageInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasMessageInput"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "videoActiveInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "videoActiveInput"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "audioActiveInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "audioActiveInput"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "textActiveInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "textActiveInput"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "recordingActiveInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "recordingActiveInput"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "setInputType", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setInputType"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "insertText", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "insertText"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onUpdateMessageInput", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onUpdateMessageInput"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onMediaReset", [_autobindDecorator["default"], _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onMediaReset"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onRecordAudio", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onRecordAudio"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onStopRecordingAudio", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onStopRecordingAudio"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "onToggleRecordAudio", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onToggleRecordAudio"), _class.prototype), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "reset", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), _class);
var _default = exports["default"] = UserInputStore;